export const isOnline = () =>
  sessionStorage.getItem('working_mode') === 'ONLINE';
